// src/admin/companies/UserCompanies.jsx — the person page's «Aziende» card and the purge dialog's «ultimo
// amministratore di…» list (BE `GET /admin/users/{id}/customers`, `last_admin_of[]`; v215). Needs a Router.
// ⭐ A company admin reaches EVERY tenant of the company with no tenant membership, so the «Tenant» card alone cannot
// explain why someone keeps access after being removed from one: this card is the other half.
// ⛔ Only the company's legal name (user data) and our sentences — never server text.
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdminTable from '../components/AdminTable.jsx';
import { companyPath } from './companyModel.js';
import { COLORS, FONT_SANS, SEMANTIC } from '../../constants/theme.js';

const ROLE_KEYS = { admin: 'userDetail.companyRoleAdmin', viewer: 'userDetail.companyRoleViewer' };

const link = { color: COLORS.accent };

// `companies` null = unknown (an older backend, a failed read): the card is not drawn.
export function UserCompaniesCard({ companies, style }) {
  const { t } = useTranslation('admin');
  if (!Array.isArray(companies)) return null;
  const administers = companies.some((c) => c.role === 'admin' && c.is_active === true);
  const columns = [
    {
      key: 'legal_name', label: t('userDetail.companyColumn'),
      render: (row) => <Link to={companyPath(row.customer_id)} style={link}>{row.legal_name || row.customer_id}</Link>,
    },
    {
      key: 'role', label: t('shared.role'), width: '160px',
      render: (row) => (ROLE_KEYS[row.role] ? t(ROLE_KEYS[row.role]) : row.role),
    },
    {
      key: 'is_active', label: t('shared.status'), width: '120px',
      render: (row) => (
        <span style={{ color: row.is_active ? SEMANTIC.verde.fg : COLORS.textSecondary }}>
          {row.is_active ? t('userDetail.companyActive') : t('userDetail.companyInactive')}
        </span>
      ),
    },
  ];
  return (
    <div style={style}>
      <h3 style={{ fontSize: '15px', fontWeight: 600, margin: '0 0 8px' }}>{t('userDetail.companiesHeading')}</h3>
      {administers && (
        <p style={{ margin: '0 0 12px', fontSize: '12px', lineHeight: 1.5, color: COLORS.textSecondary, fontFamily: FONT_SANS }}>
          {t('userDetail.companiesNote')}
        </p>
      )}
      <AdminTable
        columns={columns}
        rows={companies}
        getRowKey={(row) => row.customer_id}
        emptyMessage={t('userDetail.noCompanies')}
      />
    </div>
  );
}

// The purge dialog's blocked text when `last_admin_of[]` names the companies: our sentence, then one link each.
export function LastAdminCompanies({ companies }) {
  const { t } = useTranslation('admin');
  const list = Array.isArray(companies) ? companies : [];
  if (list.length === 0) return null;
  return (
    <>
      {t('purge.person.lastAdminOf')}
      <ul style={{ margin: '6px 0 0', paddingLeft: '18px' }}>
        {list.map((c) => (
          <li key={c.customer_id}>
            <Link to={companyPath(c.customer_id)} style={link}>{c.legal_name || c.customer_id}</Link>
          </li>
        ))}
      </ul>
    </>
  );
}
